"use client";
import { useData } from "data/data-provider";
import { FC } from "react";
import RentalCarSearchForm from "../DesignA/components/HeroSearchForm/(car-search-form)/RentalCarSearchForm";
import RentalCarSearchForm_2 from "./(car-search-form)/RentalCarSearchForm";
import { HeroSearchFormProps } from "./HeroSearchForm";

export const HeroSearchForm: FC<HeroSearchFormProps> = ({ className = "" }) => {
  const { ourCompany } = useData();
  return (
    <div
      className={`nc-HeroSearchForm w-full max-w-6xl py-5 lg:py-0 ${className} m-auto`}
    >
      {ourCompany?.allow_long_term_rentals ? (
        <RentalCarSearchForm />
      ) : (
        <RentalCarSearchForm_2 />
      )}
    </div>
  );
};
